import { shapeEntity } from '../shapeEntity';
import seasonApi, { seasonApiInstance } from './season.api';
import seasonState from './season.state';

export default shapeEntity('Season', {
    api: seasonApiInstance,
    ...seasonApi,
    useState: seasonState,
});
